import { IELTSCalculatorPlugin } from '../../DolEditor/elements/ielts-calculator/plugin';
import { IELTSScoreConverterPlugin } from '../../DolEditor/elements/ielts-score-converter/plugin';
import { PaperExamSchedulePlugin } from '../../DolEditor/elements/paper-exam-schedule/plugin';
import { CardLogicPlugin } from '../plugins/CardLogic/CardLogicPlugin';
import { IeltsCalendarComputerBasedPlugin } from '../plugins/SpecialObject/IeltsCalendar/ComputerBased/IeltsCalendarComputerBasedPlugin';
import { IeltsPurposeConverterPlugin } from '../plugins/SpecialObject/IeltsConverter/Purpose/IeltsPurposeConverterPlugin';
import { SampleSpecialObjectPlugin } from '../plugins/SpecialObject/IeltsSample/SpecialObjectPlugin';
import { SpecialObjectPlugin } from '../plugins/SpecialObject/SpecialObjectPlugin';

export const getAllSpecialObjectPlugins = ({ isReadOnly }) => [
  // special object
  CardLogicPlugin({ isReadOnly }), //
  IELTSScoreConverterPlugin({ isPreview: isReadOnly }),
  IELTSCalculatorPlugin({ isPreview: isReadOnly }),
  IeltsCalendarComputerBasedPlugin({ isReadOnly }),
  IeltsPurposeConverterPlugin({ isReadOnly }),
  SpecialObjectPlugin({ isReadOnly }), // book, course
  SampleSpecialObjectPlugin({ isReadOnly }), // writing/speaking sample
  PaperExamSchedulePlugin({ isPreview: isReadOnly }),
];
